import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;

export const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette[850]};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const InfoGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const MessageBody = styled.div`
  background: ${({ theme }) => theme.palette[50]};
  border-radius: 8px;
  padding: 16px;
  color: ${({ theme }) => theme.palette[850]};
  word-break: break-word;

  a {
    color: ${({ theme }) => theme.primary[600]};
  }
`;
